export default __webpack_public_path__ + "static/media/arrow-right.b55a98fc.svg";